import { DatePickerProps, KeyboardDatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { FieldInputProps, FormikProps, FormikValues, getIn } from "formik";
import moment from "moment";
import * as React from "react";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";

type Props<Values extends FormikValues> = DatePickerProps & {
    field: FieldInputProps<string>;
    form: FormikProps<Values>;
    middleText: boolean;
};

export const CustomDatePicker = <Values extends FormikValues>({
    style,
    label,
    field,
    form,
    placeholder,
    middleText,
    disabled,
    onChange,
    maxDate
}: Props<Values>) => {
    const fieldError = getIn(form.errors, field.name);
    const showError = getIn(form.touched, field.name) && !!fieldError;

    const handleChange = (date: MaterialUiPickersDate) => {
        form.setFieldValue(field.name, date, true);

        if (onChange) {
            onChange(date);
        }
    };

    return (
        <div
            style={{
                flexBasis: 0,
                width: "100%",
                flexGrow: 1,
                ...style
            }}
        >
            <KeyboardDatePicker
                minDate={moment().add(1, "days").toDate()}
                initialFocusedDate={moment().add(1, "days").toDate()}
                PopoverProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "right"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: 240
                    },
                    PaperProps: {
                        className: "blackDalBorder"
                    }
                }}
                autoOk
                openTo="date"
                value={field.value}
                name={field.name}
                label={label}
                disabled={disabled}
                placeholder={placeholder}
                onChange={handleChange}
                onBlur={field.onBlur}
                format={t("screen.dateFormat")}
                helperText={""}
                fullWidth
                error={showError}
                variant="inline"
                inputVariant="filled"
                inputProps={middleText ? { style: { padding: "0 0 0 12px" } } : undefined}
                InputProps={{
                    disableUnderline: true,
                    style: {
                        borderBottom: !label && showError ? `2px solid ${THEME.customColors.error}` : undefined,
                        borderTop: !label && showError ? `2px solid transparent` : undefined,
                        paddingRight: 4
                    }
                }}
                InputAdornmentProps={{
                    style: {
                        marginLeft: 0
                    }
                }}
                keyboardIcon={<img src={THEME.Images.icCalender} alt="" />}
                maxDate={maxDate}
            />
        </div>
    );
};
